(function () {
  function findMainImage(card) {
    var img = card.querySelector('img.motion-reduce');
    if (img) return img;
    var allImgs = card.querySelectorAll('img');
    for (var j = 0; j < allImgs.length; j++) {
      if (!allImgs[j].closest('.vt-wrapper')) return allImgs[j];
    }
    return null;
  }

  function findCard(el) {
    var selectors = ['.card-wrapper', '.product-card', '.card', '.grid__item', 'li', 'article'];
    for (var i = 0; i < selectors.length; i++) {
      var found = el.closest(selectors[i]);
      if (found) return found;
    }
    return null;
  }

  function findSecondaryImage(card) {
    var selectors = [
      '.card__media img:nth-child(2)',
      'img[class*="secondary"]',
      'img[class*="hover"]',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = card.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function setImage(mainImg, src) {
    var fullSrc = src.startsWith('//') ? 'https:' + src : src;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = fullSrc;
    var picture = mainImg.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) {
        s.removeAttribute('srcset');
        s.removeAttribute('sizes');
        s.srcset = fullSrc;
      });
    }
  }

  function restoreImage(mainImg, originalSrc, originalSrcset, originalSizes) {
    var fullSrc = originalSrc.startsWith('//') ? 'https:' + originalSrc : originalSrc;
    mainImg.src = fullSrc;
    if (originalSrcset) mainImg.setAttribute('srcset', originalSrcset);
    if (originalSizes) mainImg.setAttribute('sizes', originalSizes);
    var picture = mainImg.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) {
        if (originalSrcset) s.setAttribute('srcset', originalSrcset);
      });
    }
  }

  function isMouseOverElement(e, el) {
    var rect = el.getBoundingClientRect();
    return (
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom
    );
  }

  function initVariantThumbnails() {
    document.querySelectorAll('.vt-wrapper').forEach(function (wrapper) {
      var thumbs = wrapper.querySelectorAll('.vt-thumb');

      var card = findCard(wrapper);
      if (!card) return;

      var hoverImageSrc = wrapper.dataset.hoverImage || null;
      var mainImg = findMainImage(card);
      if (!mainImg) return;

      // 保存原始属性
      var originalSrc = mainImg.getAttribute('src') || '';
      var originalSrcset = mainImg.getAttribute('srcset') || '';
      var originalSizes = mainImg.getAttribute('sizes') || '';
      var secondaryImg = findSecondaryImage(card);
      var state = null;
      var overMainImg = false;

      function suppressSecondary() {
        if (secondaryImg) {
          secondaryImg.style.opacity = '0';
          secondaryImg.style.visibility = 'hidden';
          secondaryImg.style.transition = 'none';
        }
        card.setAttribute('data-vt-active', 'true');
      }

      function restoreSecondary() {
        if (secondaryImg) {
          secondaryImg.style.opacity = '';
          secondaryImg.style.visibility = '';
          secondaryImg.style.transition = '';
        }
        card.removeAttribute('data-vt-active');
      }

      function restoreAll() {
        state = null;
        overMainImg = false;
        restoreImage(mainImg, originalSrc, originalSrcset, originalSizes);
        restoreSecondary();
      }

      // 缩略图 hover：切换变体图
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('mouseenter', function (e) {
          e.stopPropagation();
          state = 'thumb';
          overMainImg = false;
          suppressSecondary();
          setImage(mainImg, this.dataset.full);
        });
      });

      // mousemove 判断鼠标是否在主图区域
      card.addEventListener('mousemove', function (e) {
        if (state === 'thumb') return;

        var nowOver = isMouseOverElement(e, mainImg);

        if (nowOver && !overMainImg) {
          overMainImg = true;
          if (hoverImageSrc && state === null) {
            state = 'hover';
            suppressSecondary();
            setImage(mainImg, hoverImageSrc);
          }
        } else if (!nowOver && overMainImg) {
          overMainImg = false;
          var overWrapper = isMouseOverElement(e, wrapper);
          if (!overWrapper && state === 'hover') {
            restoreAll();
          }
        }
      });

      // 离开整个卡片：还原
      card.addEventListener('mouseleave', function () {
        if (state !== null) {
          restoreAll();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantThumbnails);
  } else {
    initVariantThumbnails();
  }
})();
